export const STATUS = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  ERROR: 'error',
}
